import React from "react";
import {
  CardButton,
  CardFooter,
  CardHeading,
  CardHeadingWrapper,
  CardInfo,
  CardList,
  CardListItem,
  H1,
  PricingCard,
  PricingContainer,
  PricingPage,
} from "./PricingStyle";

const Pricing = () => {
  return (
    <PricingPage id="pricing">
      <H1>Plans</H1>
      <PricingContainer>
        <PricingCard data-aos="fade-left" data-aos-mirror="true">
          <CardHeadingWrapper>
            <CardHeading>Basic</CardHeading>
          </CardHeadingWrapper>

          <CardInfo>
            <CardList>
              <CardListItem>Development</CardListItem>

              <CardListItem>Design</CardListItem>

              <CardListItem>Content Management</CardListItem>
            </CardList>
            <CardFooter>
              <CardButton to="/quotation">Request quote</CardButton>
            </CardFooter>
          </CardInfo>
        </PricingCard>

        <PricingCard data-aos="fade-down" data-aos-mirror="true">
          <CardHeadingWrapper>
            <CardHeading>Standard</CardHeading>
          </CardHeadingWrapper>
          <CardInfo>
            <CardList>
              <CardListItem>Development</CardListItem>

              <CardListItem>Design</CardListItem>

              <CardListItem>Content Management</CardListItem>

              <CardListItem>Search Engine Optimization</CardListItem>
              <CardListItem>Analytics</CardListItem>
            </CardList>
            <CardFooter>
              <CardButton>Request quote</CardButton>
            </CardFooter>
          </CardInfo>
        </PricingCard>
        <PricingCard data-aos="fade-right" data-aos-mirror="true">
          <CardHeadingWrapper>
            <CardHeading>Premium</CardHeading>
          </CardHeadingWrapper>
          <CardInfo>
            <CardList>
              <CardListItem>Development</CardListItem>
              <CardListItem>Design</CardListItem>
              <CardListItem>Content Management</CardListItem>
              <CardListItem>Search Engine Optimization</CardListItem>
              <CardListItem>Analytics</CardListItem>
              <CardListItem>Maintenance</CardListItem>
              <CardListItem>Domain</CardListItem>
            </CardList>
            <CardFooter>
              <CardButton>Request quote</CardButton>
            </CardFooter>
          </CardInfo>
        </PricingCard>
      </PricingContainer>
    </PricingPage>
  );
};

export default Pricing;
